define(function(require, exports, module) {
    'use strict';

    var GoldenChipsBalancesView = require('replacers/total-goldenchips-balance/total-goldenchips-balance.view');
    var user = require('user');

    module.exports = GoldenChipsBalancesView.extend({
        subscribe: function() {
            this.listenTo(user, 'change:balance', this.render.bind(this));
        }
    });
});
